import { DocumentType } from "../enums/document-type.enum";

export class Document {
  public name: string;
  public type: DocumentType;
  public url: string;

  constructor(name: string, type: DocumentType, url: string) {
    this.name = name;
    this.type = type;
    this.url = url;
  }

  public isProfessionalBody(): boolean {
    return this.type === DocumentType.ProfessionalBody;
  }

  public isAccreditedRegister(): boolean {
    return this.type === DocumentType.AccreditedRegister;
  }

  public static mapFromFirestore(document: any): Document {
    return new Document(
      document.name,
      document.type,
      document.url
    );
  }

  public mapToFirestore(): any {
    return {
      name: this.name,
      type: this.type,
      url: this.url
    };
  }

  public static mapArrayFromFirestore(documents: any[]): Document[] {
    var documentArray = [];
    if (documents) {
      documents.forEach((document: any) => {
        documentArray.push(Document.mapFromFirestore(document));
      });
    }
    return documentArray;
  }

  public static mapArrayToFirestore(documents: Document[]): any {
    var documentArray = [];
    documents.forEach((document: Document) => {
      documentArray.push(document.mapToFirestore());
    });
    return documentArray;
  }
}
